import { render, staticRenderFns } from "./Anagraficaupload.vue?vue&type=template&id=168058af&"
import script from "./Anagraficaupload.vue?vue&type=script&lang=js&"
export * from "./Anagraficaupload.vue?vue&type=script&lang=js&"
import style0 from "./Anagraficaupload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Anagraficaupload.vue"
export default component.exports